<template>
  <transition name="fade">
    <!-- 蒙版 -->
    <div class="mask" v-if="show" @touchmove.prevent>
      <div class="window">
        <div class="window-title flex-center">
          {{ title }}
        </div>
        <p style="text-align: center;padding-top: 63px;">{{ content }}</p>
        <div class="tui-btn flex-center" @click="btnClick">
          {{ btnText }}
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      show: false,
      imgUrl: "",
      title: "",
      content: "",
      btnText: "",
      click: "",
    };
  },
  created() {},
  methods: {
    btnClick() {
      this.click();
      this.show = false;
    },
  },
};
</script>
<style lang="less" scoped>
// 渐变过渡
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s;
}
// 全局弹窗
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 75/75rem;
  .window {
    width: 470px;
    height: 242px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    box-shadow: 0px 2px 4px 0px rgba(152, 152, 152, 0.2);
    border-radius: 3px;
    .window-title {
      width: 100%;
      height: 40px;
      background: #e7f3ff;
      border: 1px solid #eaeaea;
      border-radius: 3px 3px 0px 0px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      
    }
    .tui-btn {
      width: 110px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #cdcdcd;
      border-radius: 3px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      margin: 10% auto;
    }
    .shadow {
      width: 270/75rem;
      margin-top: -90/75rem;
    }
    h1 {
      margin-top: 32/75rem;
      font-size: 32/75rem;
      color: #f1300b;
      line-height: 32/75rem;
      font-weight: 600;
    }
    p {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    button {
      margin-top: 34/75rem;
      background: #f95644;
      border-radius: 10px;
      width: 23/75remx;
      height: 64/75rem;
      font-size: 28/75rem;
      color: #ffffff;
    }
  }
  .close {
    width: 60/75rem;
    height: 60/75rem;
    margin-top: 40/75rem;
  }
}
</style>
